<template>
  <NoteSection
    label="Patient Status"
    :required="patientAge > 65"
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <help-icon
      title="Advanced Care Plan"
      body="<p>Discuss &amp; document whether an Advanced Care Plan exists in the patient's medical record.</p>
      <p><b>YES</b> = patient has an Advanced Care Plan documented in the medical record.</p>
      <p><b>NO</b> = patient does not have an Advanced Care Plan and is not able to/does not wish to provide one.</p>"
    ></help-icon>
    <radio-buttons
      v-model="advance_care_plan"
      :items="query"
      label="Patient has Advanced Care Plan?"
      class="col-sm-12"
      required
      row
      :disabled="patientAge <= 65"
    ></radio-buttons>
    <checkbox
      v-model="hospice"
      label="Patient is hospice"
      simple
    ></checkbox>
    <v-spacer
      class="mb-14"
    ></v-spacer>
  </NoteSection>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    advancedCarePlan: {
      type: Boolean,
      default: null,
    },
    patientHospice: {
      type: Boolean,
      default: null,
    },
    patientAge: {
      type: Number,
      default: null,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      advance_care_plan: this.advancedCarePlan,
      hospice: this.patientHospice,
      patient_age: this.patientAge,
    }
  },
  computed: {
    ...mapGetters('baseData', ['query']),
    // Evaluates if the Patient Status section is incomplete
    isSectionIncomplete() {
      // Advanced Care Plan is only required for patients older than 65
      if (this.patientAge <= 65) return false

      return this.advance_care_plan === null || this.advance_care_plan === undefined
    },
  },
  watch: {
    advance_care_plan() {
      this.$emit('update:advanced-care-plan', this.advance_care_plan)
    },
    hospice() {
      this.$emit('update:patient-hospice', this.hospice)
    },
  },
  methods: {
  },
}
</script>
